/* ==========================================================================
   TRIVE — Abonnement-widget redesign (v23) — JS-delen
   ==========================================================================
   Ligger som dedikeret asset-fil, linket ind i layout/theme.liquid lige
   efter custom.js (kun på produktsider, se theme.liquid).

   v23-rettelser (09.09.2026) — kundefeedback efter første fremvisning:
   - "SPAR X%"-badget var HARDKODET til "SPAR 45%" for begge mængder (1 stk.
     og 3 stk.) — kunden bad os sikre, at procenten er korrekt for begge.
     Reelt spares 36% ved 1 stk. (549→349 kr.) og 42% ved 3 stk.
     (1.647→949 kr.), altså to forskellige tal, ikke 45% for nogen af dem.
     I stedet for endnu en hardkodet konstant (som QTY_BADGE_TEXT-fejlen i
     v21 viste, går den slags stille i stå når priserne ændrer sig),
     beregnes procenten nu DYNAMISK ud fra de tal, Seal selv allerede har
     sat ind i DOM'en (.sls-original-price og .sls-price) — se
     applySavingsBadge()'s egen kommentar nedenfor. Selvrettende, uanset
     fremtidige prisændringer.
   - 3 stk.-kortets første fordels-tekst viste "949 kr/md." — men 949 kr.
     er prisen for HELE 3-måneders-leverancen, ikke pr. måned (Sebastian:
     "Det skal være hver måned"). Regex'en genkendte kun ordet "måned" og
     antog fejlagtigt at ALT med "måned" i teksten er en ren månedspris.
     Tilføjet et separat tjek for "hver X. måned"-mønstret, der udregner
     den reelle månedspris (949 ÷ 3 = 316 kr/md.) i stedet for at vise
     totalprisen. Se applyPerksIconRow()'s egen kommentar nedenfor.
   - Generel tekst-QA (Sebastian: "sikre os at teksten spiller 100%"):
     undertekst nr. 3 ("nem opsigelse") blev udtrukket direkte fra jeres
     egen plan-beskrivelse og arvede dens små bogstav — inkonsistent med de
     to andre undertekster ("Hver måned", "Prisvenligt"), som begge er med
     stort forbogstav. Tilføjet en generel stort-forbogstav-normalisering,
     så alle tre undertekster nu er konsekvente, uanset kildetekstens egen
     stavning.

   v21-rettelse (08.09.2026): QTY_BADGE_TEXT ("SPAR 48 DKK" på "3 stk."-
   pillen) var forældet. Genberegnet ud fra de AKTUELLE abonnement-priser
   (tjekket direkte i Shopify Admin 08.09.2026, Sebastian spurgte om
   tallet stadig var korrekt): "Hver måned" (1 stk.) koster 349 kr.,
   "Hver 3. måned" (3 stk. på én leverance) koster 949 kr. 3× separate
   månedlige leverancer ville koste 3 × 349 kr. = 1.047 kr. — altså en
   besparelse på 1.047 − 949 = 98 kr. ved i stedet at tage 3 stk. på én
   gang. Opdateret fra 48 til 98 kr. (bekræftet stadig korrekt 09.09.2026
   mod aktuelle Shopify-priser — denne værdi ER stadig hardkodet, se
   QTY_BADGE_TEXT's egen kommentar nedenfor for hvorfor den ikke også blev
   gjort dynamisk i v23).

   v19-rettelse (08.09.2026, samme dag som v18): v18's "vis altid"-fix for
   Abonnements beskrivelse/badge brugte style.removeProperty("display"), i
   den tro at det ville afsløre den korrekte, synlige tilstand. Det gjorde
   det ikke — Seal Subscriptions har sin egen eksterne CSS (som vi ikke kan
   læse, cross-origin), der selv skjuler beskrivelse/badge på ikke-valgte
   kort, og removeProperty faldt bare tilbage til DEN skjulte styling. Rettet
   ved at sætte display eksplicit til "block" med !important i stedet for
   at fjerne egenskaben — se de to funktioners egne kommentarer nedenfor.

   KRITISK FIX (01.09.2026): scriptet ligger i <head>, lige efter custom.js,
   og køres derfor SYNKRONT mens browseren stadig parser <head> — <body>
   findes ikke endnu på det tidspunkt. observer.observe(document.body, ...)
   kastede derfor en uncaught TypeError, som stoppede resten af scriptet
   (MutationObserver + alle setTimeout-sikkerhedsnet) i at køre overhovedet.
   Løsning: hele initialiseringen venter nu på DOMContentLoaded.

   Hvorfor JS i stedet for kun CSS: Seal Subscriptions-widgetten og temaets
   variant-picker er begge JS-rendered og opdaterer sig selv, når kunden
   skifter mellem Abonnement/Engangskøb eller 1 stk./3 stk.

   data-tv-plan (sat af tagPlanTypes ud fra titel-teksten) bruges til det,
   der skal forblive fast uanset valg: rækkefølge, Engangskøb-label, og
   (fra v18) hele Abonnement-kortets udseende.

   v18-rettelser (08.09.2026):
   - "Abonnement lukker ned, når man klikker Engangskøb" (Sebastian: "Den
     eneste ændring skal være, at radio button ændrer sig. Alt andet skal
     være det samme"): applyTitleColor(), applyDescriptionVisibility() og
     applyBadgeVisibility() gjorde alle Abonnements styling betinget af
     ".sls-active" — når Engangskøb blev valgt, mistede Abonnement sin hvide
     titel, sine fordele/beskrivelse OG sit badge på én gang, hvilket så
     ud som om kortet "lukkede ned". Alle tre funktioner er ændret til at
     behandle Abonnement (data-tv-plan="subscription") ens, uanset om det er
     valgt eller ej — kun selve radioknappens udseende (styret af CSS'ens
     ".sls-active .sls-custom-radio", ikke af disse JS-funktioner) afspejler
     nu valget. Engangskøb er UÆNDRET: skjuler stadig altid sin beskrivelse
     og får aldrig hvid titel/badge, uanset valgt eller ej.

   v17-rettelser (04.09.2026):
   - Genindført applyTitleColor() (fra v15, uændret logik dengang): satte
     inline hvid titel-farve på Abonnement, når den var valgt (nødvendigt
     fordi inline !important altid vinder over CSS !important) — men aldrig
     på Engangskøb, uanset valgt eller ej. (v18: "når den var valgt"-delen
     er nu fjernet for Abonnement, se ovenfor.)

   v15-rettelser (04.09.2026):
   - applyTitleColor() satte ubetinget titlen til hvid (inline style med
     !important) på ETHVERT valgt kort, inkl. Engangskøb. Da inline styles
     med !important altid vinder over eksterne CSS-regler med !important,
     uanset selector-specificitet, kunne CSS-fix af Engangskøbs titel-farve
     aldrig slå igennem i praksis — titlen blev ved med at blive hvid,
     selvom CSS'en sagde noget andet. isOneTime-tjekket sikrer, at
     Engangskøbs titel aldrig får den hvide inline-farve.

   v14-rettelser (04.09.2026):
   - Engangskøb skal ALDRIG vise sin beskrivelse, heller ikke når valgt.

   v13-rettelser (04.09.2026):
   - De faste setTimeout-sikkerhedsnet er skåret ned fra
     [500, 1000, 2000, 4000] ms til [100, 300] ms, så redesignet ikke
     visuelt "popper ind" mærkbart sent efter sideindlæsning.

   v12-rettelser:
   - applyDescriptionVisibility() tjekkede kun .sls-selling-plan-description-
     content, men Engangskøbs beskrivelse ligger i en helt anden klasse
     (.sls-one-time-description-content) — tjekker nu begge klasser pr. kort.
   - applyPerksIconRow() er flyttet fra den debouncede gruppe til den
     synkrone gruppe, så USP-ikonrækken ikke bygges ca. 50ms senere end
     resten af kortet.
   - MutationObserver'en indsnævret til produkt-info-kolonnen i stedet for
     hele document.body, med fald-back til #MainContent/document.body.
   ========================================================================== */

(function () {
  "use strict";

  function whenDomReady(fn) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn);
    } else {
      fn();
    }
  }

  // Ekstra besparelse ved 3 stk. i stedet for 3× 1 stk. — opdatér manuelt,
  // hvis priserne ændres. Genberegnet 08.09.2026 ud fra de aktuelle
  // abonnement-priser i Shopify Admin: "Hver måned" = 349 kr., "Hver 3.
  // måned" (3 stk. på én leverance) = 949 kr. 3 × 349 kr. = 1.047 kr. mod
  // 949 kr. ved 3 stk. på én gang = 98 kr. i besparelse.
  //
  // v23: forblev bevidst HARDKODET, i modsætning til SPAR-badget nedenfor
  // (som blev gjort dynamisk). Denne sammenligning er mellem to FORSKELLIGE
  // abonnement-planers pris (3× "Hver måned"-prisen vs. "Hver 3.
  // måned"-prisen), og på det tidspunkt brugeren ser mængde-vælgeren, er
  // kun ÉN af de to planers pris til stede i DOM'en (den valgte). Der er
  // ikke et tilsvarende "original vs. rabatteret"-talpar at læse
  // automatisk, sådan som der er for SPAR-badget. Skal opdateres manuelt,
  // hvis priserne ændres.
  var QTY_BADGE_TEXT = "SPAR 98 DKK";
  var ONE_TIME_LABEL_TEXT = "Køb som engangskøb";

  function extractPrice(text) {
    var m = text.match(/[\d.,]+\s*kr/i);
    return m ? m[0].replace(/\s+/g, " ").trim() : null;
  }

  // v23: samme udtræk som extractPrice(), men som et rent tal (ikke en
  // formateret streng) — bruges til at REGNE på prisen (fx dele totalprisen
  // for en 3-måneders-leverance med 3 for at finde månedsprisen), i stedet
  // for kun at vise den. Håndterer dansk talformat (punktum som
  // tusindtalsseparator, komma som decimal), selvom priserne på denne side
  // i praksis altid er hele kroner uden decimaler.
  function extractPriceNumber(text) {
    var priceStr = extractPrice(text);
    if (!priceStr) return null;
    var digits = priceStr
      .replace(/[^\d.,]/g, "")
      .replace(/\./g, "")
      .replace(",", ".");
    var n = parseFloat(digits);
    return isNaN(n) ? null : n;
  }

  // v23: samme formål som extractPriceNumber(), men til at parse Seals egne
  // .sls-original-price / .sls-price-elementer (bruges af
  // applySavingsBadge() nedenfor). Adskilt fra extractPriceNumber(), fordi
  // disse elementers tekst ikke nødvendigvis indeholder ordet "kr" i samme
  // form (fx kan valuta-symbolet sidde andre steder afhængig af Seals egen
  // rendering) — matcher derfor bare det første tal i teksten.
  function parsePriceKr(text) {
    if (!text) return null;
    var cleaned = text
      .replace(/[^\d.,]/g, "")
      .replace(/\./g, "")
      .replace(",", ".");
    var n = parseFloat(cleaned);
    return isNaN(n) ? null : n;
  }

  // v23: første bogstav med stort — bruges til at normalisere undertekster,
  // der er udtrukket direkte fra jeres egen plan-beskrivelse og derfor kan
  // arve dens egen (inkonsekvente) stavning, fx "nem opsigelse" med lille
  // begyndelsesbogstav. Se applyPerksIconRow()'s "binding"-gren nedenfor.
  function capitalizeFirst(str) {
    if (!str) return str;
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  function tagPlanTypes() {
    var cards = document.querySelectorAll(".sls-option-container.seal-table");
    Array.prototype.forEach.call(cards, function (card) {
      var nameEl = card.querySelector(".sls-selling-plan-group-name");
      var text = nameEl ? nameEl.textContent : "";
      var isOneTime = /engang/i.test(text) || /one[\s-]?time/i.test(text);
      card.setAttribute("data-tv-plan", isOneTime ? "onetime" : "subscription");
    });
  }

  function applyQtyBadge() {
    var pills = document.querySelectorAll(".product-variant-picker__pill-list .pill");
    if (pills.length < 2) return;
    var target = pills[1];
    if (target.querySelector(".tv-qty-badge")) return;
    var badge = document.createElement("span");
    badge.className = "tv-qty-badge";
    badge.textContent = QTY_BADGE_TEXT;
    target.appendChild(badge);
  }

  // v23: var tidligere hardkodet til "SPAR 45%" for BEGGE mængder (1 stk.
  // og 3 stk.), hvilket var forkert for begge (reelt 36% og 42%, se filens
  // v23-note øverst). Beregnes nu i stedet direkte ud fra de tal, Seal selv
  // allerede har skrevet ind i DOM'en for det AKTUELT VALGTE kort
  // (.sls-original-price = den overstregede pris, .sls-price = den
  // rabatterede pris) — korrekt for enhver mængde/plan uden manuel
  // vedligeholdelse, og opdaterer sig selv automatisk, hvis priserne
  // ændres i Shopify fremover.
  function applySavingsBadge() {
    var card = document.querySelector('[data-tv-plan="subscription"]');
    if (!card) return;
    var badge = card.querySelector(".sls-savings-badge");
    var origEl = card.querySelector(".sls-original-price");
    var priceEl = card.querySelector(".sls-price");
    if (!badge || !origEl || !priceEl) return;
    var orig = parsePriceKr(origEl.textContent);
    var price = parsePriceKr(priceEl.textContent);
    if (orig == null || price == null || orig <= price) return;
    var pct = Math.round(((orig - price) / orig) * 100);
    var text = "SPAR " + pct + "%";
    if (badge.textContent.trim() !== text) {
      badge.textContent = text;
    }
  }

  function applyOneTimeLabel() {
    var label = document.querySelector(
      '.sls-option-container.seal-table[data-tv-plan="onetime"] .sls-selling-plan-group-name'
    );
    if (label && label.textContent.trim() !== ONE_TIME_LABEL_TEXT) {
      var onlyText = Array.prototype.every.call(label.childNodes, function (n) {
        return n.nodeType === 3;
      });
      if (onlyText) label.textContent = ONE_TIME_LABEL_TEXT;
    }
  }

  function applyPerksIconRow() {
    var ul = document.querySelector('[data-tv-plan="subscription"] .sls-selling-plan-description-content > ul');
    if (!ul || ul.dataset.tvDone === "1") return;

    var items = Array.prototype.slice.call(ul.querySelectorAll(":scope > li"));
    if (items.length === 0) return;

    items.forEach(function (li) {
      var original = li.textContent.trim();
      var icon, label, sub;

      // v23: "Hver 3. måned" (eller enhver "hver X. måned"-plan med X>1)
      // skal IKKE vises som om totalprisen var en månedspris — se filens
      // v23-note øverst. Tjekkes FØR det generiske "måned"-tjek nedenfor,
      // som ellers ville fange denne tekst først (den indeholder jo også
      // ordet "måned") og fejlagtigt vise fx "949 kr/md." i stedet for den
      // reelle månedspris.
      var multiMonth = original.match(/hver\s+(\d+)\.?\s*måned/i);

      if (/for altid/i.test(original)) {
        icon = "calendar";
        label = extractPrice(original) ? extractPrice(original) + "/md." : original;
        sub = "For altid*";
      } else if (multiMonth && parseInt(multiMonth[1], 10) > 1) {
        var intervalMonths = parseInt(multiMonth[1], 10);
        var totalPrice = extractPriceNumber(original);
        icon = "calendar";
        label =
          totalPrice != null
            ? Math.round(totalPrice / intervalMonths) + " kr/md."
            : original;
        sub = "Hver måned";
      } else if (/måned/i.test(original) || /\/\s*md\.?/i.test(original)) {
        icon = "calendar";
        label = extractPrice(original) ? extractPrice(original) + "/md." : original;
        sub = "Hver måned";
      } else if (/portion/i.test(original)) {
        icon = "price";
        label = extractPrice(original) ? extractPrice(original) + "/portion" : original;
        sub = "Prisvenligt";
      } else if (/binding/i.test(original)) {
        icon = "lock";
        label = "Ingen binding";
        sub =
          capitalizeFirst(
            original.replace(/^.*binding[^a-zæøå]*/i, "").trim()
          ) || "Nem opsigelse";
      } else {
        icon = "price";
        label = original;
        sub = "";
      }

      li.innerHTML =
        '<span class="tv-label">' + label + "</span>" +
        (sub ? '<span class="tv-sub">' + sub + "</span>" : "");
      li.setAttribute("data-icon", icon);
      li.classList.add("tv-item");
    });

    ul.classList.add("tv-icon-row");
    ul.dataset.tvDone = "1";
  }

  // v18: Abonnement skal have hvid titel ALTID (ikke kun når valgt) — kun
  // Engangskøb er undtaget. Se filens v18-note øverst.
  function applyTitleColor() {
    var cards = document.querySelectorAll(".sls-option-container.seal-table");
    Array.prototype.forEach.call(cards, function (card) {
      var label = card.querySelector(".sls-selling-plan-group-name");
      if (!label) return;
      var isOneTime = card.getAttribute("data-tv-plan") === "onetime";
      var isWhite = !isOneTime;
      if (isWhite) {
        label.style.setProperty("color", "#ffffff", "important");
      } else {
        label.style.removeProperty("color");
      }
      Array.prototype.forEach.call(label.querySelectorAll("*"), function (el) {
        if (el.closest(".sls-savings-badge")) return;
        if (isWhite) {
          el.style.setProperty("color", "#ffffff", "important");
        } else {
          el.style.removeProperty("color");
        }
      });
    });
  }

  // v18: Abonnement viser ALTID sin beskrivelse/fordele (ikke kun når
  // valgt). Engangskøb er uændret: skjuler altid sin, uanset valgt eller
  // ej. Se filens v18-note øverst.
  //
  // VIGTIGT (v18, opdaget ved test): Seal Subscriptions har sin EGEN
  // eksterne CSS-fil (cdn-app.sealsubscriptions.com), som vi ikke kan læse
  // (cross-origin), men som browseren stadig bruger til at style siden.
  // Den skjuler tilsyneladende selv beskrivelsen på ikke-valgte kort. Et
  // "removeProperty('display')" fjerner kun VORES egen inline-override og
  // falder derefter tilbage til netop den skjulte Seal-styling — det var
  // derfor Abonnements fordele/gaveboks forsvandt, selvom denne funktion
  // ikke længere skulle skjule dem for Abonnement. Løsning: sæt display
  // eksplicit til "block" med !important i stedet for at fjerne egenskaben
  // — inline !important vinder altid, uanset hvad Seals egen CSS gør.
  function applyDescriptionVisibility() {
    var cards = document.querySelectorAll(".sls-option-container.seal-table");
    Array.prototype.forEach.call(cards, function (card) {
      var contents = card.querySelectorAll(
        ".sls-selling-plan-description-content, .sls-one-time-description-content"
      );
      if (!contents.length) return;
      var isOneTime = card.getAttribute("data-tv-plan") === "onetime";
      Array.prototype.forEach.call(contents, function (content) {
        if (isOneTime) {
          content.style.setProperty("display", "none", "important");
        } else {
          content.style.setProperty("display", "block", "important");
        }
      });
    });
  }

  // v18: Abonnements SPAR-badge vises ALTID (ikke kun når valgt; selve
  // procent-teksten beregnes af applySavingsBadge() ovenfor, se v23-note).
  // Badget findes strukturelt kun i Abonnement-kortets markup, så det
  // dukker uanset op aldrig ved et uheld op på Engangskøb. Samme
  // "removeProperty vs. setProperty"-fælde som applyDescriptionVisibility()
  // ovenfor (Seals egen CSS skjuler badget på ikke-valgte kort) — sætter nu
  // også eksplicit "block" med !important i stedet for at fjerne egenskaben.
  function applyBadgeVisibility() {
    var cards = document.querySelectorAll(".sls-option-container.seal-table");
    Array.prototype.forEach.call(cards, function (card) {
      var badge = card.querySelector(".sls-savings-badge");
      if (!badge) return;
      var isOneTime = card.getAttribute("data-tv-plan") === "onetime";
      if (isOneTime) {
        badge.style.setProperty("display", "none", "important");
      } else {
        badge.style.setProperty("display", "block", "important");
      }
    });
  }

  function applyGiftText() {
    // Eksempel når I har givet mig teksten:
    // var el = document.querySelector(".flask-promo-box .flask-text");
    // if (el) el.textContent = "DEN NYE GAVE-TEKST HER";
  }

  function applyGiftGratisHighlight() {
    var box = document.querySelector(".flask-promo-box .flask-text");
    if (!box || box.querySelector(".tv-gratis")) return;

    var walker = document.createTreeWalker(box, NodeFilter.SHOW_TEXT, null);
    var node;
    while ((node = walker.nextNode())) {
      var idx = node.nodeValue.search(/gratis/i);
      if (idx === -1) continue;
      var match = node.nodeValue.slice(idx, idx + "gratis".length);
      var before = node.nodeValue.slice(0, idx);
      var after = node.nodeValue.slice(idx + match.length);

      var span = document.createElement("span");
      span.className = "tv-gratis";
      span.textContent = match;

      var parent = node.parentNode;
      if (before) parent.insertBefore(document.createTextNode(before), node);
      parent.insertBefore(span, node);
      if (after) parent.insertBefore(document.createTextNode(after), node);
      parent.removeChild(node);
      break;
    }
  }

  function applyImmediate() {
    tagPlanTypes();
    applyQtyBadge();
    applySavingsBadge();
    applyOneTimeLabel();
    applyTitleColor();
    applyDescriptionVisibility();
    applyBadgeVisibility();
    applyPerksIconRow();
  }

  function applyDeferred() {
    applyGiftText();
    applyGiftGratisHighlight();
  }

  function applyAll() {
    applyImmediate();
    applyDeferred();
  }

  whenDomReady(function () {
    applyAll();

    var observerRoot =
      document.querySelector("product-info") ||
      document.querySelector(".product__info-wrapper") ||
      document.getElementById("MainContent") ||
      document.body;

    var debounceTimer = null;
    var observer = new MutationObserver(function () {
      applyImmediate();
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(applyDeferred, 50);
    });
    observer.observe(observerRoot, { childList: true, subtree: true });

    [100, 300].forEach(function (ms) {
      setTimeout(applyAll, ms);
    });
  });
})();
